<template>
  <div v-if="show" class="container">
    <div class="head-container">
      <!-- <div class="logo" :style="'background-image: url('+$_syscfg.index_log+')'" @click="goIndex()"></div> -->
      <div class="headline">
        <div class="left-container">
          <img v-show="!hideBack" @click="close" class="back" src="./assets/backGrey.png" alt="">
          <i v-if="!detail.isStream" :title="detail.has_audit==1 ? '技审通过' : detail.has_audit==2 ? '技审未通过' : ''" :class="{assessIcon: true, success: detail.has_audit==1, fail: detail.has_audit==2}"></i>
          <p :title="titleInput" v-if="!showInput" v-html="titleInput"></p>
          <input v-if="showInput" v-model="titleInput" @keydown.enter="showInput = false;renameAsset()" class="nameInput" type="text">
          <img v-if="!showInput && canEdit" @click="showInput = true" class="rename" src="./assets/reName.png" alt="">
          <span v-if="showInput">{{wordNum}}/40</span>
        </div>
        <div class="right-container">
          <div v-if="(detail.has_low_quality_download_role || detail.has_high_quality_download_role || detail.has_publish_quality_download_role) && detail.type != 1 && detail.type != 3 && !isStream" v-click-outside="closeDownload" :class="{btn: true, download: true, on: showDownload}">
            <i @click="showDownload = true"></i>
            <p @click="showDownload = true">下载</p>
            <ul v-show="showDownload">
              <li @click="downloadSource(detail,2)" v-if="detail.has_publish_quality_download_role
 && detail.from_kankan" class="k">
                <i></i>
                <p>发布码流</p>
              </li>
              <li @click="downloadSource(detail,0)" v-if="detail.has_low_quality_download_role && !detail.from_kankan" class="k">
                <i></i>
                <p>800K码流</p>
              </li>
              <li @click="downloadSource(detail,1)" v-if="detail.has_high_quality_download_role" class="hd">
                <i></i>
                <p>原始码流</p>
              </li>
            </ul>
          </div>
          <div @click="downloadSource(detail,1)" v-if="(detail.has_low_quality_download_role || detail.has_high_quality_download_role) && detail.type != 1 && detail.type != 3 && isStream" :class="{btn: true, download: true}">
            <i @click="showDownload = true"></i>
            <p @click="showDownload = true">下载</p>
          </div>
          <div @click="downloadSource(detail,1)" v-if="(detail.has_low_quality_download_role || detail.has_high_quality_download_role) && detail.type == 1" :class="{btn: true, download: true}">
            <i @click="showDownload = true"></i>
            <p @click="showDownload = true">下载</p>
          </div>
          <div @click="downloadSource(detail,1)" v-if="(detail.has_low_quality_download_role || detail.has_high_quality_download_role) && detail.type == 3" :class="{btn: true, download: true}">
            <i @click="showDownload = true"></i>
            <p @click="showDownload = true">下载</p>
          </div>
          <div v-if="detail.edit_role && !isStream" @click="edit(detail.type)" class="btn edit">
            <i></i>
            <p>编辑</p>
          </div>
          <div v-if="(create.material || create.report || create.publish || create.new_media) && !isStream" v-click-outside="closeCreate" :class="{btn: true, create: true, on: showCreate}">
            <i @click="showCreate = true"></i>
            <p @click="showCreate = true">创建</p>
            <ul v-show="showCreate">
              <li v-if="create.material" @click="navigate('material',detail.id)" class="clue">
                <i></i>
                <p>上传线索</p>
              </li>
              <li v-if="create.report" @click="navigate('report',detail.id)" class="report">
                <i></i>
                <p>创建报道</p>
              </li>
              <li v-if="create.publish" @click="navigate('publish',detail.id)" class="publish">
                <i></i>
                <p>创建发布</p>
              </li>
              <li v-if="create.new_media" @click="navigate('new_media',detail.id)" class="new_media">
                <i></i>
                <p>新媒体发布</p>
              </li>
            </ul>
          </div>

          <div v-if="!isStream" @click="showMore = true" v-click-outside="closeMore" :class="{more: true, on: showMore}">
            <i></i>
            <ul v-show="showMore">
              <li v-if="quickEdit" @click="useDetail" class="use">
                <i></i>
                <p>选用</p>
              </li>
              <li v-if="detail.has_stream_send" @click="mediaSend" class="pack">
                <i></i>
                <p>归档</p>
              </li>
              <li v-if="detail.has_share" @click="$ShareCode(detail.id)" class="share">
                <i></i>
                <p>分享</p>
              </li>
              <li v-if="canEdit" @click="showInput = true" class="rename">
                <i></i>
                <p>重命名</p>
              </li>
              <li v-if="canEdit" @click="delDetail(detail.id)" class="del">
                <i></i>
                <p>删除</p>
              </li>
            </ul>
          </div>

          <div v-if="isStream" v-click-outside="closeMaterial" class="callbackMaterial">
            <p @click="submitCallback(3);showToMaterial = false">{{callback_type == 1 ? '回调至我的素材' : '回调至素材库'}}</p>
            <i @click="showToMaterial = !showToMaterial" :class="{on: !showToMaterial}"></i>
            <ul v-if="showToMaterial">
              <li @click="submitCallback(1);showToMaterial = false" class="myMaterial">
                <i></i>
                <p>回调至我的素材</p>
              </li>
              <li @click="submitCallback(2);showToMaterial = false" class="materialBin">
                <i></i>
                <p>回调至素材库</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="content-container">
      <div class="left-container">
        <img @click="pre" v-if="list.length > 0" :style="'position: absolute;top:50%;left:'+iconMargin+'px;width:'+iconWidth+'px;height:'+iconWidth+'px;margin-top:-'+iconWidth/2+'px;cursor: pointer;'" src="./assets/pre.png">
        <img @click="next" v-if="list.length > 0" :style="'position: absolute;top:50%;right:'+iconMargin+'px;width:'+iconWidth+'px;height:'+iconWidth+'px;margin-top:-'+iconWidth/2+'px;cursor: pointer;'" src="./assets/next.png">
        <div class="media-container" :style="'width:'+ width +'px; height:'+ height +'px;'">
          <div v-show="detail.type-0 === 2" class="video">
            <video ref="videoDom" controls controlsList="nodownload" contextmenu="none" :src="detail.url"></video>
            <div class="speedRate">
              <div @click="showSelectList=!showSelectList" class="btn">
                <span>{{nowSpeed}}</span>
                <img src="@assets/img/material/whiteArrow.svg" alt="">
              </div>
              <div v-if="showSelectList" class="btnList">
                <p></p>
                <ul>
                  <li @click="changeSpeed('1x')">1x</li>
                  <li @click="changeSpeed('2x')">2x</li>
                  <li @click="changeSpeed('4x')">4x</li>
                </ul>
              </div>
            </div>
          </div>
          <div ref="imgDom" v-show="detail.type-0 === 1" :style="{'background-image': `url(${detail.url})`}" class="img">
            <div v-for="(i,index) in picFaceList" :key="index" class="border" :style="'width:'+i.borderWidth+'px;height:'+i.borderHeight+'px;top:'+i.borderTop+'px;left:'+i.borderLeft+'px;'">
              <i>{{++index}}</i>
            </div>
          </div>
          <div v-show="detail.type-0 === 3" class="audio">
            <audio ref="audioDom" preload="load" :src="detail.url"></audio>
            <div :style="'width:'+logoWidth+'px; height:'+logoWidth+'px; margin-top:'+marginTop+'px;margin-bottom:'+marginBottom+'px'" class="control">
              <img :style="'width:'+logoWidth+'px; height:'+logoWidth+'px'" src="@assets/img/material/disk.png" alt="">
              <img @click="audioPlay" v-if="isPlay === false" class="play" src="@assets/img/material/playIcon.svg" alt="">
              <img @click="audioPause" v-if="isPlay" class="pause" src="@assets/img/material/pauseIcon.svg" alt="">
            </div>
            <div class="progress-container">
              <div class="time">
                <span>{{nowTime}}</span>
                <span class="grey">/{{endTime}}</span>
              </div>
              <div ref="line" class="progress">
                <p @click="isMouseClick=true;clickJump($event)" class="progress-bg"></p>
                <p @click="isMouseClick=true;clickJump($event)" class="progress-fill" :style="'width:' + audioPercent">
                  <i @mouseenter.prevent="isMouseClick=false" @mouseout.prevent="timeNavi();isMouseClick=false;" @mousedown.prevent="isMouseClick=true;timeStop();isPlayAudio=false" @mouseup.prevent="timeNavi();isMouseClick=false;"
                    @mousemove.prevent="slideMouseMove"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :style="'width:' + right" class="right-container">
        <ul class="toolBar">
          <li @click="tag = 'detail'" :class="{detail: true, on: tag === 'detail'}">
            <i></i>
            <p>详情</p>
          </li>
          <li @click="tag = 'doc'" :class="{doc: true, on: tag === 'doc'}">
            <i></i>
            <p>文稿</p>
          </li>
          <li v-if="hasAiRole" @click="tag = 'ai'" :class="{ai: true, on: tag === 'ai'}">
            <i></i>
            <p>AI</p>
          </li>
          <li v-if="config.search_hit" @click="tag = 'xl'" :class="{xl: true, on: tag === 'xl'}">
            <i></i>
            <p>图像</p>
          </li>
          <li @click="isFold = !isFold" class="fold">
            <i :class="{on: isFold}"></i>
          </li>
        </ul>
        <div v-if="!isFold" class="content">
          <ul class="tab-list">
            <li v-if="item.isShow && type != 'newMaterialArticleDetail' && !isSHowResult" v-for="(item,index) in tagList[tag]" :key="index" @click="type = item.type" :class="{tab: true, on: type === item.type}">{{item.name}}</li>
            <li @click="type = 'newMaterialArticle'" class="backArticle" v-if="type === 'newMaterialArticleDetail'">
              <img src="./assets/back.png" alt="">
              <p>返回</p>
            </li>
            <li @click="clearSearch" class="backArticle" v-if="type === 'newMaterialArticle' && isSHowResult">
              <img src="./assets/back.png" alt="">
              <p>返回</p>
            </li>
          </ul>
          <div class="content">
            <components ref="comp" :vector_result="this.config.vector_result" :keywords="this.config.keywords" @closeBg="closeBg" @cahngeSummary="cahngeSummary" @showResult="showResult" @clickFun="clickFun" @faceStatus="faceStatus" @voiceStatus="voiceStatus" @faceList="faceList" @toTime="toTime" @getId="getId" @timeJump="timeJump" :data="detail" :newOpen="newOpen" :width="width" :height="height" :articleDetail="articleDetail" :canEdit="canEdit" :create="create" :quickEdit="quickEdit" :is="type"></components>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import store from "@common/store";
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      isDetailComplete: false,
      newOpen: false,
      hideBack: false,
      list: [],
      listIndex: 0,
      callback_type: 1,
      isStream: false,
      isMyMaterial: false,
      show: false,
      right: '446px',
      showDownload: false,
      showCreate: false,
      showMore: false,
      showInput: false,
      isFold: false,
      type: 'newMaterialDetail',
      tagList: {
        detail: [
          {name: '详情', type: 'newMaterialDetail', isShow: true},
          {name: '标签', type: 'newMaterialTag', isShow: true}
        ],
        doc: [
          {name: '相关文稿', type: 'newMaterialArticle', isShow: true}
        ],
        ai: [
          {name: '语音识别', type: 'newMaterialVoiceRec', isShow: true},
          {name: '人脸识别', type: 'newMaterialFaceRec', isShow: true},
          {name: '技术审核', type: 'newMaterialAssess', isShow: true}
        ],
        xl: [
          {name: '素材片段', type: 'newMaterialXl', isShow: true}
        ]
      },
      nowSpeed: "1x",
      tag: 'detail',
      reName: '',
      titleInput: '',
      saveTitleInput: '',
      r: null,
      callback: null,
      o: '',
      canEdit: false,
      create: {
        interview: false,
        material: false,
        publish: false,
        report: false
      },
      quickEdit: true,
      t: {},
      d: {},
      config: '',
      detail: {},
      wordNum: 0,
      articleDetail: {},
      width: 696,
      height: 445,
      logoWidth: 212,
      marginTop: 0,
      marginBottom: 0,
      picFaceList: [],
      isPlay: false,
      nowTime: "00:00:00",
      endTime: "00:00:00",
      duration: 0,
      percent: 0,
      audioPercent: "0%",
      isMouseClick: false,
      showSelectList: false,
      isSHowResult: false,
      hasAiRole: true,
      showToMaterial: false,
      materialCanShare: true,
      iconWidth: 36,
      iconMargin: 30
    }
  },
  watch: {
    titleInput() {
      this.watchTitle();
    },
    isFold(to) {
      if(to){
        this.right = '50px'
      }else{
        this.right = '446px'
      }
    },
    tag(to) {
      if(to === 'detail'){
        this.picFaceList = []
        this.type = 'newMaterialDetail'
      }else if(to === 'doc'){
        this.picFaceList = []
        this.type = 'newMaterialArticle'
      }else if(to === 'ai'){
        if(this.detail.type - 0 === 1){
          this.picFaceList = []
          this.type = 'newMaterialFaceRec'
        }else if(this.detail.type - 0 === 2){
          this.picFaceList = []
          if(this.detail.has_pickup_text_role){
            this.type = 'newMaterialVoiceRec'
          }else if(this.detail.has_face_rec){
            this.type = 'newMaterialFaceRec'
          }else if(this.detail.has_audit_role){
            this.type = 'newMaterialAssess'
          }
        }else if(this.detail.type - 0 === 3){
          this.picFaceList = []
          this.type = 'newMaterialVoiceRec'
        }
      }else if(to === 'xl'){
        this.type = 'newMaterialXl'
      }
    },
    "store.state.tag": function (e) {
      console.log(123123)
      this.close()
    }
  },
  methods: {
    getS(time) {
      var hour = time.split(":")[0];
      var min = time.split(":")[1];
      var sec = time.split(":")[2];
      var s = (parseFloat(hour * 3600) + parseFloat(min * 60) + parseFloat(sec)).toFixed(
          3
      );
      return s;
    },
    timeJump(e) {
      let s = this.getS(e)
      this.$refs.videoDom.currentTime = s
      this.$refs.videoDom.play()
    },
    mediaSend() {
      let info = {
          subject_type: 10,
          subject_id: this.detail.id
      };
      common
      .myFetch(apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    pre() {
      if(this.listIndex==0){
        this.listIndex = this.list.length - 1
      }else{
        this.listIndex --
      }
      this.getDetail(this.list[this.listIndex].id);
      this.tag = 'detail'
    },
    next() {
      if(this.listIndex==this.list.length - 1){
        this.listIndex = 0
      }else{
        this.listIndex ++
      }
      this.getDetail(this.list[this.listIndex].id);
      this.tag = 'detail'
    },
    closeBg() {
      this.close()
    },
    submitCallback(callback_type) {
      if(callback_type != 3){
        this.callback_type = callback_type;
      }else{
        callback_type = this.callback_type;
      }
      
      const info = {
        id: this.detail.id,
        type: this.detail.type,
        callback_type: callback_type
      };
      common.myFetch(apis.streammediaCallback, info).then(r => {
        if (r) {
          // console.log(r)
          this.$toast('发起回调任务')
        }
      });
    },
    closeMaterial() {
      console.log(111)
      this.showToMaterial = false;
    },
    cahngeSummary(e) {
      this.detail.info = e
    },
    clearSearch() {
      this.$refs.comp.clearSearch()
    },
    showResult(e) {
      this.isSHowResult = e
    },
    async delDetail(id) {
      let msg = `确认删除素材？`;
      const confirm = await this.$confirm(msg);
      if(!confirm) return
      if(this.o){
        const info = {
          idstring: this.detail.idstring,
          subject_id: this.o.d,
          subject_type: this.o.t
        };
        common.myFetch(apis.File_delete, info).then(r => {
          if (r) {
            store.commit("setflashPic1", true);
            if(this.hideBack){
              this.$toast(r);
              this.close('del')
              // window.close()
            }else{
              this.$toast(r);
              this.close()
            }
          }
        });
      }else{
        let data = {
          file_ids: ""
        };
        if (id) {
          data.file_ids = id;
        }
        if (data.file_ids) {
          common.myFetch(apis.File_delmyfile, data).then(res => {
            if (res) {
              store.commit("setflashPic1", true);
              console.log(this.callback)
              // this.callback()
              this.$toast(res);
              this.close()
            }
          });
        } else {
          this.$toast("请选择素材");
        }
      }
    },
    useDetail() {
      let data = {
        file_ids: this.detail.id
      };

      common.myFetch(apis.File_addquickfile, data).then(res => {
        if (res) {
          this.$toast("已成功加入选用素材");
          store.commit("setQuickEditNum", res.quick_edit_num);
        }
      });
    },
    clickFun() {
      console.log(1)
      this.test()
    },
    voiceStatus(e) {
      this.detail.text_status = 2
    },
    faceStatus(e) {
      this.detail.face_status = 2
    },
    toTime(s) {
      if(this.detail.type-0 === 3){
        this.$refs.audioDom.currentTime = (s/100).toFixed(2)
        this.$refs.audioDom.play()
        this.isPlay = true;
      }else if(this.detail.type-0 === 2){
        this.$refs.videoDom.currentTime = (s/100).toFixed(2)
        this.$refs.videoDom.play()
      }
    },
    changeSpeed(speed) {
      const video = this.$refs.videoDom;
      this.nowSpeed = speed;
      let multiple = 1;
      if (speed === "1x") {
        multiple = 1;
      } else if (speed === "2x") {
        multiple = 2;
      } else {
        multiple = 4;
      }
      video.playbackRate = multiple;
      this.showSelectList = false;
    },
    open(c, r, call, o) {
      document.body.style.overflowY = 'hidden'
      store.commit("setflashPic1", false);
      this.r = r;
      this.callback = call;
      if (o) {
        console.log(1111111111111)
        this.o = o;
        if(o.newOpen){
          this.newOpen = true
        }
        this.hideBack = o.hideBack
        this.canEdit = o.canEdit || false;
        if(o.create){
          this.create = o.create;
        }
        this.quickEdit = o.quickEdit;
        this.t = o.t;
        this.d = o.d;
        this.list = this.o.list
        this.listIndex = this.o.index
        console.log(this.o)
        this.isDetailComplete = o.isDetailComplete
        this.getDetail(this.o.list[this.o.index].id);
      } else {
        console.log(222222222)
        this.hideBack = c.hideBack
        this.config = c;
        this.canEdit = c.canEdit || false;
        if(c.newOpen){
          this.newOpen = true
        }
        if(c.create){
          this.create = c.create;
        }
        this.quickEdit = c.quickEdit;
        this.t = c.t;
        this.d = c.d;
        this.isStream = c.isStream
        this.isMyMaterial = c.isMyMaterial
        console.log(this.config)
        this.isDetailComplete = c.isDetailComplete
        if(this.isStream){
          this.getStreamDetail(this.config.id,this.config.type);
        }else{
          this.getDetail(this.config.id,this.config.keywords,this.config.search_from,this.config.search_hit);
        }
      }
      this.show = true;
      
      this.$nextTick(() => {
        this.disableContextMenu()
      })
    },
    disableContextMenu() {
      // 隐藏右键菜单
      if(this.$refs.imgDom){
        this.$refs.imgDom.oncontextmenu = function(event) {
          return false
        }
      }

      if(this.$refs.videoDom){
        this.$refs.videoDom.oncontextmenu = function(event) {
          return false
        }
      }

      if(this.$refs.audioDom){
        this.$refs.audioDom.oncontextmenu = function(event) {
          return false
        }
      }
    },
    close(e) {
      if(this.$refs.audioDom){
        this.$refs.audioDom.pause();
      }
      if(this.$refs.videoDom){
        this.$refs.videoDom.pause();
        this.$refs.videoDom.removeAttribute('src');
        this.$refs.videoDom.load();
        this.$refs.videoDom = null;
      }
      document.body.style.overflowY = 'auto'
      if(e == 'del' && this.hideBack){
        this.r(e)
      }
      this.closeCallBack()
      this.show = false;
    },
    goIndex() {
      // this.$router.push({
      //   path: "/index"
      // });
      this.close();
      common.jump(`/index`, false);
    },
    getId(e) {
      this.articleDetail = e;
      this.type = 'newMaterialArticleDetail'
    },
    getStreamDetail(id, type) {
      let data = {
        id: id,
        type: type
      }

      return common.myFetch(apis.streammediaDetail, data).then(r => {
        if(r){
          console.log(r)
          this.detail = r.detail
          this.detail.isStream = this.isStream
          this.titleInput = this.detail.title;
          this.saveTitleInput = this.detail.title;

          this.$nextTick(() => {
            if(this.detail.type - 0 === 1){
              this.tagList['ai'].forEach(el => {
                if(el.type === 'newMaterialFaceRec'){
                  if(this.detail.has_face_rec){
                    el.isShow = true
                  }else{
                    el.isShow = false
                  }
                }else{
                  el.isShow = false
                }
              })
            }else if(this.detail.type - 0 === 2){
              this.tagList['ai'].forEach(el => {
                if(el.type === 'newMaterialVoiceRec'){
                  if(this.detail.has_pickup_text_role){
                    el.isShow = true
                  }else{
                    el.isShow = false
                  }
                }if(el.type === 'newMaterialFaceRec'){
                  if(this.detail.has_face_rec){
                    el.isShow = true
                  }else{
                    el.isShow = false
                  }
                }if(el.type === 'newMaterialAssess'){
                  if(this.detail.has_audit_role){
                    el.isShow = false
                  }else{
                    el.isShow = false
                  }
                }
              })
              setTimeout(() => {
                this.$refs.videoDom.play();
              }, 500);
            }else if(this.detail.type - 0 === 3){
              this.tagList['ai'].forEach(el => {
                if(el.type === 'newMaterialVoiceRec'){
                  if(this.detail.has_pickup_text_role){
                    el.isShow = true
                  }else{
                    el.isShow = false
                  }
                }else{
                  el.isShow = false
                }
              })
              setTimeout(() => {
                this.audioLoad()
              }, 500);
            }
          })
        }
      })
    },
    getDetail(id, keywords, search_from, search_hit) {
      // 获取详情接口
      return common.myFetch(apis.file_detail, { id, keywords: keywords ? keywords : '', search_from: search_from ? search_from : '', search_hit: search_hit ? search_hit : '' }).then(r => {
        if (r) {
          this.detail = r.detail;
          console.log('getDetail r', r);

          this.titleInput = this.detail.title;
          this.saveTitleInput = this.detail.title;

          // type 图片是1.视频是2.音频是3
          if(this.detail.type - 0 === 1){
            this.tagList['ai'].forEach(el => {
              if(el.type === 'newMaterialFaceRec'){
                if(this.detail.has_face_rec){
                  el.isShow = true
                }else{
                  el.isShow = false
                }
              }else{
                el.isShow = false
              }
            })
          }else if(this.detail.type - 0 === 2){
            this.tagList['ai'].forEach(el => {
              if(el.type === 'newMaterialVoiceRec'){
                if(this.detail.has_pickup_text_role){
                  el.isShow = true
                }else{
                  el.isShow = false
                }
              }if(el.type === 'newMaterialFaceRec'){
                if(this.detail.has_face_rec){
                  el.isShow = true
                }else{
                  el.isShow = false
                }
              }if(el.type === 'newMaterialAssess'){
                if(this.detail.has_audit_role){
                  el.isShow = true
                }else{
                  el.isShow = false
                }
              }
            })
            setTimeout(() => {
              this.$refs.videoDom.play();
            }, 500);
          }else if(this.detail.type - 0 === 3){
            this.tagList['ai'].forEach(el => {
              if(el.type === 'newMaterialVoiceRec'){
                if(this.detail.has_pickup_text_role){
                  el.isShow = true
                }else{
                  el.isShow = false
                }
              }else{
                el.isShow = false
              }
            })
            
            setTimeout(() => {
              this.audioLoad()
            }, 500);
            // this.$nextTick(() => {
            //   this.audioLoad()
            // })
          }

          let index = 0;

          this.tagList['ai'].forEach(el => {
            if(!el.isShow){
              index++
            }
          })

          if(index == 3){
            this.hasAiRole = false
          }

          // 如果是通过左右点击切换素材，tabIndex回到0
          // if (hint === "click") {
          //   this.tabIndex = 0;
          // }

          this.$nextTick(() => {
            if((this.config && this.config.toTag) || (this.o && this.o.toTag)){
              this.type = 'newMaterialTag'
            }

            if((this.config && this.config.toAi) || (this.o && this.o.toAi)){
              this.tag = 'ai'
              this.type = 'newMaterialVoiceRec'
            }
          })
        }
      });
    },
    watchTitle() {
      let str = this.titleInput;
      this.getLength(str);
    },
    getLength(str) {
      var n = null;
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) >= 0 && str.charCodeAt(i) <= 256) {
          n += 0.5;
        } else {
          n += 1;
        }
      }

      if (n <= 40) {
        this.saveTitleInput = this.titleInput;
      } else {
        this.titleInput = this.saveTitleInput;
      }

      this.wordNum = Math.floor(n);
    },
    renameAsset() {
      if (!this.titleInput) return;
      const info = {
        idstring: this.detail.idstring,
        title: this.titleInput
      };

      common.myFetch(apis.File_rename, info).then(r => {
        if (r) {
          this.$toast(r);
          this.showInput = false;
          this.$set(this.detail, "title", this.titleInput);
          // this.callback();
        }
      });
    },
    closeDownload() {
      this.showDownload = false;
    },
    closeCreate() {
      this.showCreate = false;
    },
    closeMore() {
      this.showMore = false;
    },
    downloadSource(source, type) {
      if (type === 0) {
        if (!this.detail.has_low_quality_download_role) {
          this.$toast("无下载权限");
          return;
        } else {
          if (source.type != 1) {
            if (source.content.status != 1) {
              this.$toast("转码尚未完成");
              return;
            }
          }
        }
      } else if (type === 1) {
        if(this.detail.type == 1){
          if (!this.detail.has_high_quality_download_role&&!this.detail.has_low_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }else if(this.detail.type == 3) {
          if (!this.detail.has_high_quality_download_role&&!this.detail.has_low_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }else{
          if (!this.detail.has_high_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }
      } else if (type === 2) {
        if (!this.detail.has_publish_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
      }

      if(this.isStream){
        const info = {
          id: source.id,
          type: this.detail.type || 0
        };

        const url = apis.streammediaDownload;
        const userKeys = common.userKeys();
        const params = Object.assign({}, info, userKeys);

        common.myFetch(url, params).then(r => {
          if (r) {
            // console.log(r)

            var link,evt;
        
            link = document.createElement('a');
            link.href = r.download_url;
            link.setAttribute('download', '');
            if(document.fireEvent) {
                window.open(link.href);
            }else {
                evt = document.createEvent('MouseEvents');
                evt.initEvent('click', true, true);
                link.dispatchEvent(evt);
            }
          }
        });

        // console.log(params)
      }else{
        const info = {
          idstring: source.idstring,
          file_quality: type || 0
          // subject_type: 0,
          // subject_id: this.$route.query.d
        };
        const url = apis.File_download;
        const userKeys = common.userKeys();
        const params = Object.assign({}, info, userKeys);

        common.exportRes(url, params, 1);
      }

      this.showDownload = false;
    },
    test() {
      // console.log(this.callback)
      if (this.callback) {
        this.callback();
      }
    },
    closeCallBack() {
      if (this.callback) {
        // console.log(this.callback)
        if(this.isMyMaterial){
          this.callback({
            id: this.detail.id,
            title: this.titleInput,
            type: this.detail.type
          });
        }else{
          this.callback();
        }
      }
    },
    edit(type) {
      if (type - 0 === 1) {
        this.editPic(this.detail);
      } else if (type - 0 === 2) {
        let info = {}
        if(this.isDetailComplete){
          info = {
            title: this.detail.title,
            id: this.detail.id,
            d: '',
            t: ''
          }
        }else{
          info = {
            title: this.detail.title,
            id: this.detail.id,
            d: this.d || this.detail.id || '',
            t: this.t || ''
          }
        }
        this.$cloudEditConfirm(info).then((res) => {
          if(res != 999){
            window.open(res.meisheurl)
          }
        })
        // console.log(this.detail)
      } else if (type - 0 === 3) {
        this.editVideo(this.detail.text_status, this.detail);
      }
    },
    editPic(i) {
      i.canEdit = this.canEdit
      console.log(i)
      if (this.t == null && this.d == null) {
        i.t = null;
        i.d = this.detail.id;
      } else {
        i.t = this.t;
        i.d = this.d;
      }
      i.canEdit = true
      this.$picEditType1(i, this.test).then(el => {
        console.log(el)
        if (Number(el) == '123') {
          console.log(true)
          if(this.hideBack){
            this.r('pic')
          }
          store.commit('setflashPic1', true)
        }
      });
    },
    editVideo(i, j) {
      j.canEdit = this.canEdit
      console.log(i, j);
      let newObj = {
        pageType: null,
        pageId: null,
        file_format: this.detail.upload.url,
        appId: this.detail.upload.app_id,
        appSecret: this.detail.upload.app_secret
      };
      Object.assign(j, newObj);
      this.$voiceEditType(i, j).then(res => {
        console.log(res, i);
        console.log(this.t,this.d)
        if (res == 0 && i == 3 && res !== false) {
          // console.log(this.pageType,this.$route.query.d,j)
          const newWindow = window.open();
          // console.log(`${window.location.origin}/voiceEdit/${this.pageType}/${this.$route.query.d}/${j.idstring}`)
          if(this.canEdit){
            newWindow.location.href = `${window.location.origin
            }/voiceEdit/${this.t}/${this.d}/${j.idstring
            }`;
          }else{
            let s = 'undefined'
            let a = 'undefined'
            newWindow.location.href = `${window.location.origin
            }/voiceEdit/${s}/${a}/${j.idstring
            }`;
          }
          // newWindow.location.href = `${window.location.origin
          //   }/voiceEdit/${this.t}/${this.d}/${j.idstring
          //   }`;
        } else if (res == "peComplete") {
          this.test();
        }
      });
    },
    async navigate(type, id) {
      if (type === "material") {
        let info = {
          id: id,
          push_to: type,
          type: 0
        };
        common.myFetch(apis.File_filepush, info).then(r => {
          if (r) {
            common.jump(`/creatClue?t=0&d=${r.id}`, true);
          }
        });
      } else if (type === "report") {
        const typeName = await this.$pageType();
        if (!typeName) return;
        let info = {
          id: id,
          push_to: type,
          type: typeName
        };
        common.myFetch(apis.File_filepush, info).then(r => {
          if (r) {
            common.jump(`/creatReport?t=${typeName}&d=${r.id}`, true);
          }
        });
      } else if (type === "publish") {
        const typeName = await this.$pageType("publish");
        if (!typeName) return;
        let info = {
          id: id,
          push_to: type,
          type: typeName
        };
        common.myFetch(apis.File_filepush, info).then(r => {
          if (r) {
            common.jump(`/createPublish?t=${typeName}&d=${r.id}`, true);
          }
        });
      } else if (type === "new_media") {
        const typeName = await this.$MediaPlatform();
        if (!typeName) return;
        let info = {
          file_ids: id,
          subject_type: 5,
          subject_id: typeName
        };
        common.myFetch(apis.File_bind, info).then(r => {
          if (r) {
            common.jump(`/createMediaPublish?d=${typeName}`, true);
          }
        });
      }
    },
    faceList(e) {
      console.log(e)
      this.picFaceList = e
    },
    audioPlay(){
      this.$refs.audioDom.play();
      this.isPlay=true;
    },
    audioPause(){
      console.log(99999)
      this.$refs.audioDom.pause();
      this.isPlay=false;
    },
    clickJump(e) {
      let clientX = this.$refs.line.getBoundingClientRect().x;
      let width = this.$refs.line.getBoundingClientRect().width;
      let left = 0;
      let percent = 0;

      if (e.clientX - clientX <= 0) {
        left = "0%";
      } else if (e.clientX - clientX >= this.$refs.line.getBoundingClientRect().width) {
        left = "100%";
      } else {
        percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
        left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
      }

      this.percent = percent;
      this.audioPercent = left;

      // this.$refs.sliderLeft.style.width = left;

      this.timeNavi();

      this.isMouseClick = false;
    },
    timeNavi() {
      if (this.isMouseClick) {
        let percent = this.percent / 100;
        let time = (percent * this.duration).toFixed(2);
        this.$refs.audioDom.currentTime = time;
        this.$refs.audioDom.play();
        this.isPlay = true;
        this.isMouseClick = false;
      }
    },
    timeStop() {
      this.isPlay = false;
      this.$refs.audioDom.pause();
    },
    slideMouseMove(e) {
      // return false;
      if (this.isMouseClick) {
        let clientX = this.$refs.line.getBoundingClientRect().x;
        let width = this.$refs.line.getBoundingClientRect().width;
        let left = 0;
        let percent = 0;

        if (e.clientX - clientX <= 0) {
          left = "0%";
        } else if (e.clientX - clientX >= this.$refs.line.getBoundingClientRect().width) {
          left = "100%";
        } else {
          percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
          left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
        }

        this.nowTime = this.s2hms(
          (this.$refs.audioDom.duration * percent) / 100
        );

        this.percent = percent;
        this.audioPercent = left;

        // this.$refs.sliderLeft.style.width = left;
      }
    },
    s2hms(time) {
      var min = Math.floor(time % 3600);
      var hh =
        Math.floor(time / 3600) < 10
          ? "0" + Math.floor(time / 3600)
          : Math.floor(time / 3600);
      var mm =
        Math.floor(min / 60) < 10
          ? "0" + Math.floor(min / 60)
          : Math.floor(min / 60);
      var ss = time % 60 < 10 ? "0" + parseInt(time % 60) : parseInt(time % 60);
      return hh + ":" + mm + ":" + ss;
      // console.log(hh + ":" + mm + ":"+ ss)
    },
    audioLoad() {
      let that = this;
      that.duration = parseInt(that.$refs.audioDom.duration);
      that.endTime = that.s2hms(parseInt(that.$refs.audioDom.duration));
      console.log(that.$refs.audioDom.duration,that.endTime)
      if(isNaN(that.$refs.audioDom.duration)){
        that.endTime = '00:00:00'
      }
      that.nowTime = that.s2hms(parseInt(that.$refs.audioDom.currentTime));
      if(isNaN(that.nowTime)){
        that.nowTime = '00:00:00'
      }
      var percent =
        (
          (parseInt(that.$refs.audioDom.currentTime) /
            parseInt(that.$refs.audioDom.duration)) *
          100
        ).toFixed(2) + "%";
      that.audioPercent = percent;

      this.$refs.audioDom.play();
      this.isPlay = true;

      this.$refs.audioDom.ontimeupdate = function (e) {
        that.nowTime = that.s2hms(parseInt(e.target.currentTime));
        let percent =
          (
            (parseInt(e.target.currentTime) / parseInt(e.target.duration)) *
            100
          ).toFixed(2) + "%";
        that.audioPercent = percent;
      };

      this.$refs.audioDom.onended = function () {
        that.isPlay = false;
      };
    },
    getVideoAudit(msg) {
      console.log('通知技审结果变化 getVideoAudit', msg)
      let { content: { id, pickup } } = msg.content
      console.log('id', id)
      console.log('pickup', pickup)
      if (id == this.detail.id) {
          this.$toast(pickup);
          this.getDetail(id)
      }
    },
    recalc() {
      var clientWidth = document.documentElement.clientWidth;

      if (!clientWidth) {

          return;
      }

      var p = 100 * (clientWidth / 1334);

      if(p<100){
        p=100
      }

      this.width = 6.96*p
      this.height = 4.45*p

      this.logoWidth = 2.12*p

      this.marginTop = (this.height -this.logoWidth)/2

      this.marginBottom = 0.24*p

      this.iconWidth = 0.36*p

      this.iconMargin = 0.3*p
    }
  },
  mounted() {
    let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

    window.addEventListener(resizeEvt, this.recalc, false);

    document.addEventListener('DOMContentLoaded', this.recalc, false);

    history.pushState(null, null, document.URL);

    window.addEventListener('popstate', this.close, false);

    this.recalc()

    common.handleSocket(this.getVideoAudit, "audit");
    
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";

.container {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  width: 100%;
  height: 100vh;
  background: #FAFBFC;

  .head-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 70px;
    background: #FFFFFF;
    box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.05);
    border-bottom: 1px solid #EBEDF8;
    box-sizing: border-box;

    .logo {
      .site_logo;
      width: 230px;
      height: 70px;
      background-color: @dark;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      // box-shadow: 6px 6px 20px 0 rgba(5, 10, 15, 0.2);
      z-index: 1;
      cursor: pointer;
      .name {
        width: 100px;
        margin-left: 20px;
      }
    }

    .headline {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100vw;
      height: 70px;
      padding: 0 20px;
      box-sizing: border-box;

      .left-container {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: calc(100vw - 380px);
        .assessIcon {

          &.success {
            width: 22px;
            height: 22px;
            display: block;
            margin-left: 10px;
            background: url('./assets/successIcon.png') no-repeat;
            background-size: 100% 100%;
            background-position: center center;
          }

          &.fail {
            width: 22px;
            height: 22px;
            display: block;
            margin-left: 10px;
            background: url('./assets/failIcon.png') no-repeat;
            background-size: 100% 100%;
            background-position: center center;
          }
        }

        .nameInput {
          // width: 598px;
          flex: 1;
          height: 45px;
          font-size: 24px;
          color: #050F0F;
          font-weight: bold;
          border-bottom: 1px solid #D9D9D9;
          box-sizing: border-box;
          margin: 0 10px;
          padding: 0 50px 0 0;
        }

        img {
          user-select: none;
          cursor: pointer;
        }

        .back {
          width: 30px;
          height: 30px;
        }

        p {
          font-size: 24px;
          color: #0B131F;
          font-weight: bold;
          margin: 0 10px;
          // max-width: 550px;
          // flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .rename {
          width: 22px;
          height: 22px;
        }

        span {
          position: absolute;
          right: 10px;
          font-size: 14px;
          color: #829191;
          font-weight: bold;
        }
      }

      .right-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        min-width: 320px;

        .btn {
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 32px;
          line-height: 32px;
          padding: 0 15px;
          box-sizing: border-box;
          font-size: 14px;
          color: #829191;
          font-weight: bold;
          user-select: none;
          cursor: pointer;
          background: rgba(185, 195, 195, 0.2);
          border-radius: 4px;
          margin-right: 14px;

          &:hover {
            background: #41B48C;
            color: #FFFFFF;

            &.download {
              i {
                display: block;
                width: 18px;
                height: 18px;
                background: url('./assets/downloadOn.svg') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                margin-right: 4px;
              }
            }

            &.edit {
              i {
                display: block;
                width: 18px;
                height: 18px;
                background: url('./assets/editOn.svg') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                margin-right: 4px;
              }
            }

            &.create {
              background: #3DA983;
              // color: #829191;

              i {
                display: block;
                width: 18px;
                height: 18px;
                background: url('./assets/createOn.svg') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                margin-right: 4px;
              }
            }
          }

          &.on {
            &.download {
              background: #41B48C;
              color: #FFF;

              i {
                display: block;
                width: 18px;
                height: 18px;
                background: url('./assets/downloadOn.svg') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                margin-right: 4px;
              }
            }

            &.create {
              background: #41B48C;
              color: #FFF;

              i {
                display: block;
                width: 18px;
                height: 18px;
                background: url('./assets/createOn.svg') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                margin-right: 4px;
              }
            }
          }

          &.download {
            i {
              display: block;
              width: 18px;
              height: 18px;
              background: url('./assets/download.svg') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              margin-right: 4px;
            }

            ul {
              position: absolute;
              top: 38px;
              left: -27px;
              z-index: 1;
              display: flex;
              flex-direction: column;
              padding: 7px 0;
              box-sizing: border-box;
              background: rgba(0, 0, 0, 0.8);
              border-radius: 4px;
              overflow: hidden;

              li {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 134px;
                height: 34px;
                font-size: 14px;
                color: #FFFFFF;
                font-weight: bold;
                padding-left: 20px;
                box-sizing: border-box;

                &:hover {
                  color: #41B48C;

                  &.k {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/download/800kOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }

                  &.hd {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/download/hdOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }
                }

                &.k {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/download/800k.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }

                &.hd {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/download/hd.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }
              }
            }
          }

          &.edit {
            i {
              display: block;
              width: 18px;
              height: 18px;
              background: url('./assets/edit.svg') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              margin-right: 4px;
            }
          }

          &.create {
            background: #41B48C;
            color: #FFF;

            i {
              display: block;
              width: 18px;
              height: 18px;
              background: url('./assets/createOn.svg') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              margin-right: 4px;
            }

            ul {
              position: absolute;
              top: 38px;
              left: -27px;
              z-index: 1;
              display: flex;
              flex-direction: column;
              padding: 7px 0;
              box-sizing: border-box;
              background: rgba(0, 0, 0, 0.8);
              border-radius: 4px;
              overflow: hidden;

              li {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 134px;
                height: 34px;
                font-size: 14px;
                color: #FFFFFF;
                font-weight: bold;
                padding-left: 20px;
                box-sizing: border-box;

                &:hover {
                  color: #41B48C;

                  &.clue {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/create/clueOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }

                  &.report {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/create/reportOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }

                  &.publish {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/create/publishOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }

                  &.new_media {
                    i {
                      display: block;
                      width: 18px;
                      height: 18px;
                      background: url('./assets/create/newMediaIconOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }
                }

                &.clue {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/create/clue.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }

                &.report {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/create/report.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }

                &.publish {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/create/publish.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }

                &.new_media {
                  i {
                    display: block;
                    width: 18px;
                    height: 18px;
                    background: url('./assets/create/newMediaIcon.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }
              }
            }
          }
        }

        .more {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 32px;
          height: 32px;
          background: rgba(185, 195, 195, 0.2);
          border-radius: 2px;
          user-select: none;
          cursor: pointer;

          &.on {
            background: #41B48C;

            i {
              display: block;
              width: 12px;
              height: 12px;
              background: url('./assets/moreOn.svg') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
            }
          }

          ul {
              position: absolute;
              top: 38px;
              right: 0;
              z-index: 1;
              display: flex;
              flex-direction: column;
              padding: 7px 0;
              box-sizing: border-box;
              background: rgba(0, 0, 0, 0.8);
              border-radius: 4px;
              overflow: hidden;

              li {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 134px;
                height: 34px;
                font-size: 14px;
                color: #FFFFFF;
                font-weight: bold;
                padding-left: 20px;
                box-sizing: border-box;

                &:hover {
                  color: #41B48C;

                  &.use {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/more/useOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }

                  &.share {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/more/shareOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }

                  &.file {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/more/fileOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }

                  &.pack {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/more/packOn.png') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }

                  &.rename {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/more/renameOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }

                  &.del {
                    i {
                      display: block;
                      width: 20px;
                      height: 20px;
                      background: url('./assets/more/delOn.svg') no-repeat;
                      background-size: 100% 100%;
                      background-position: center center;
                      margin-right: 10px;
                    }
                  }
                }

                &.use {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/more/use.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }

                &.share {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/more/share.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }

                &.file {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/more/file.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }

                &.pack {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/more/pack.png') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }

                &.rename {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/more/rename.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }

                &.del {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/more/del.svg') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 10px;
                  }
                }
              }
            }

          &:hover {
            background: #41B48C;

            i {
              display: block;
              width: 12px;
              height: 12px;
              background: url('./assets/moreOn.svg') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
            }
          }

          i {
            display: block;
            width: 12px;
            height: 12px;
            background: url('./assets/more.svg') no-repeat;
            background-size: 100% 100%;
            background-position: center center;
          }
        }

        .callbackMaterial {
          position: relative;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 148px;
          height: 32px;
          background: #41B48C;
          border-radius: 4px;
          user-select: none;
          cursor: pointer;

          & > p {
            font-size: 14px;
            color: #FFF;
            font-size: bold;
          }

          & > i {
            display: block;
            width: 10px;
            height: 10px;
            background: url('./assets/whiteArrow.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-left: 10px;

            &.on {
              transform: rotate(180deg);
            }
          }

          ul {
            position: absolute;
            right: 0;
            top: 38px;
            z-index: 99;
            width: 168px;
            padding: 7px 20px;
            background: rgba(0, 0, 0, 0.8);
            border-radius: 4px;
            box-sizing: border-box;

            li {
              display: flex;
              flex-direction: row;
              // justify-content: space-between;
              align-items: center;
              width: 100%;
              height: 34px;
              line-height: 34px;

              &.myMaterial {
                &:hover {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/toMyMaterialOn.svg') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                  }

                  p {
                    font-size: 14px;
                    color: #41B48C;
                    font-weight: bold;
                  }
                }

                i {
                  display: block;
                  width: 20px;
                  height: 20px;
                  background: url('./assets/toMyMaterial.svg') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 10px;
                }

                p {
                  font-size: 14px;
                  color: #FFFFFF;
                  font-weight: bold;
                }
              }

              &.materialBin {
                &:hover {
                  i {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url('./assets/toMaterialBinOn.svg') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                  }

                  p {
                    font-size: 14px;
                    color: #41B48C;
                    font-weight: bold;
                  }
                }

                i {
                  display: block;
                  width: 20px;
                  height: 20px;
                  background: url('./assets/toMaterialBin.svg') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 10px;
                }

                p {
                  font-size: 14px;
                  color: #FFFFFF;
                  font-weight: bold;
                }
              }
            }
          }
        }
      }
    }
  }

  .content-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    height: calc(100vh - 70px);
    
    .left-container {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      background: #FAFBFC;

      .media-container {
        position: relative;
        width: 696px;
        height: 392px;
        background-color: rgba(185,195,195,0.1);

        .video {
          position: relative;
          width: 100%;
          height: 100%;

          video {
            width: 100%;
            height: 100%;
            background: #000;
          }

          .speedRate {
            position: absolute;
            top: 14px;
            right: 14px;

            .btn {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              width: 62px;
              height: 30px;
              border-radius: 15px;
              background: rgba(0, 0, 0, 0.3);
              user-select: none;
              cursor: pointer;

              span {
                display: block;
                font-size: 16px;
                line-height: 30px;
                color: #fff;
              }

              img {
                margin-left: 4px;
              }
            }

            .btnList {
              display: flex;
              flex-direction: column;

              p {
                height: 10px;
              }

              ul {
                display: flex;
                flex-direction: column;
                border-radius: 4px;
                overflow: hidden;
                background: rgba(0, 0, 0, 0.3);

                li {
                  width: 100%;
                  height: 30px;
                  line-height: 30px;
                  text-align: center;
                  font-size: 16px;
                  color: #fff;
                  user-select: none;
                  cursor: pointer;

                  &:hover {
                    background: rgba(0, 0, 0, 0.5);
                  }
                }
              }
            }
          }
        }

        .img {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
          background-color: #000;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;

          .border {
            position: absolute;
            top: 0;
            left: 0;
            border: 2px solid #ff555a;
            border-radius: 6px;
            box-sizing: border-box;

            i {
              position: absolute;
              top: -10px;
              left: -10px;
              display: block;
              width: 20px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 14px;
              color: #fff;
              border-radius: 50%;
              background-color: #ff4153;
            }
          }
        }

        .audio {
          // display: flex;
          // flex-direction: column;
          // justify-content: center;
          width: 100%;
          height: 100%;
          padding: 0 30px;
          box-sizing: border-box;
          // background: #f9f9f9;

          audio {
            display: none;
          }

          .control {
            position: relative;
            width: 199px;
            margin: 0 auto 0;
            // padding-top: 84px;
            box-sizing: border-box;
            margin-bottom: 21px;

            .play {
              position: absolute;
              top: 50%;
              left: 50%;
              margin-left: -30px;
              margin-top: -42px;
              user-select: none;
              cursor: pointer;
            }

            .pause {
              position: absolute;
              top: 50%;
              left: 50%;
              margin-left: -12px;
              margin-top: -20px;
              user-select: none;
              cursor: pointer;
            }
          }

          .progress-container {
            display: flex;
            flex-direction: column;
            width: 100%;
            // width: 598px;
            // margin: 0 auto;

            .time {
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
              font-size: 13px;
              line-height: 15px;
              color: #829191;
              font-weight: bold;
              font-family: Arial;
              margin-bottom: 8px;

              span {
                display: block;
              }

              .grey {
                color: #b9c3c3;
              }
            }

            .progress {
              position: relative;
              width: 100%;
              user-select: none;

              .progress-bg {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 3px;
                border-radius: 1.5px;
                background-color: rgba(151, 151, 151, 0.2);
              }

              .progress-fill {
                position: absolute;
                top: 0;
                left: 0;
                width: 0%;
                height: 3px;
                border-radius: 1.5px;
                background-color: @green;

                i {
                  position: absolute;
                  top: 50%;
                  right: -7px;
                  margin-top: -7px;
                  display: block;
                  width: 14px;
                  height: 14px;
                  border-radius: 50%;
                  background: #75C6AA;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }

    .right-container {
      display: flex;
      flex-direction: row;

      .toolBar {
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 50px;
        height: 100%;
        background: #FFFFFF;
        border-radius: 2px;
        border-left: 1px solid #F0F0F0;
        border-right: 1px solid #F0F0F0;
        box-sizing: border-box;
        padding: 14px 0;

        li {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 12px;
          font-weight: bold;
          color: #9CA6AC;
          margin-bottom: 20px;
          user-select: none;
          cursor: pointer;

          p {
            line-height: 17px;
          }

          &.detail {

            &.on {
              &::after {
                display: block;
                content: '';
                position: absolute;
                top: 3.5px;
                left: 0;
                width: 2px;
                height: 40px;
                background: #41B48C;
              }
              color: #41B48C;
              i {
                display: block;
                width: 30px;
                height: 30px;
                background: url('./assets/detailOn.svg') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
              }
            }

            i {
              display: block;
              width: 30px;
              height: 30px;
              background: url('./assets/detail.svg') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
            }
          }

          &.doc {
            
            &.on {
              &::after {
                display: block;
                content: '';
                position: absolute;
                top: 3.5px;
                left: 0;
                width: 2px;
                height: 40px;
                background: #41B48C;
              }
              color: #41B48C;
              i {
                display: block;
                width: 30px;
                height: 30px;
                background: url('./assets/docOn.svg') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
              }
            }

            i {
              display: block;
              width: 30px;
              height: 30px;
              background: url('./assets/doc.svg') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
            }
          }

          &.ai {

            &.on {
              &::after {
                display: block;
                content: '';
                position: absolute;
                top: 3.5px;
                left: 0;
                width: 2px;
                height: 40px;
                background: #41B48C;
              }
              color: #41B48C;
              i {
                display: block;
                width: 30px;
                height: 30px;
                background: url('./assets/aiOn.svg') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
              }
            }

            i {
              display: block;
              width: 30px;
              height: 30px;
              background: url('./assets/ai.svg') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
            }
          }

          &.xl {

            &.on {
              &::after {
                display: block;
                content: '';
                position: absolute;
                top: 3.5px;
                left: 0;
                width: 2px;
                height: 40px;
                background: #41B48C;
              }
              color: #41B48C;
              i {
                display: block;
                width: 30px;
                height: 30px;
                background: url('./assets/xlOn.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
              }
            }

            i {
              display: block;
              width: 30px;
              height: 30px;
              background: url('./assets/xl.png') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
            }
          }

          &.fold {
            position: absolute;
            bottom: 0;
            left: 10px;

            i {
              display: block;
              width: 30px;
              height: 30px;
              background: url('./assets/fold.png') no-repeat;
              background-size: 100% 100%;
              background-position: center center;

              &.on {
                display: block;
                width: 30px;
                height: 30px;
                background: url('./assets/foldOn.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
              }
            }
          }
        }
      }

      & > .content {
        width: 396px;
        height: 100%;
        display: flex;
        flex-direction: column;

        .tab-list {
          display: flex;
          flex-direction: row;
          width: 100%;
          height: 50px;
          background: #FFFFFF;
          box-shadow: 0px 1px 0px 0px rgba(5, 10, 15, 0.05);

          .backArticle {
            display: flex;
            flex-direction: row;
            align-items: center;
            user-select: none;
            cursor: pointer;

            img {
              width: 20px;
              height: 20px;
              margin: 0 4px 0 20px;
            }

            p {
              font-size: 16px;
              line-height: 22px;
              color: #050F0F;
              font-weight: bold;
            }
          }

          .tab {
            position: relative;
            height: 50px;
            font-size: 16px;
            color: #050F0F;
            font-weight: bold;
            line-height: 50px;
            padding: 0 30px;
            border-bottom: 2px solid transparent;
            box-sizing: border-box;
            user-select: none;
            cursor: pointer;

            &::after {
              position: absolute;
              top: 50%;
              right: 0;
              display: block;
              content: '';
              width: 1px;
              height: 18px;
              background: #F0F0F0;
              margin-top: -9px;
            }

            &:nth-last-of-type(1) {
              &::after {
                display: none;
              }
            }

            &.on {
              color: #41B48C;
              border-bottom: 2px solid #41B48C;
            }
          }
        }

        .content {
          flex: 1;
          width: 100%;
          min-height: 0;
          background: #FFF;
          margin-top: 1px;
          // overflow-y: auto;

          &::-webkit-scrollbar {
            width: 6px;
          }
          &::-webkit-scrollbar-thumb {
            background: rgba(#D8D8D8, 1);
            border-radius: 5px;
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.headline {
  em {
    color: #41b48c;
    font-style: normal;
  }
}
</style>